(function () {
  var fab = document.getElementById('bb-fab');
  var toggle = document.getElementById('bb-fab-toggle');
  var closeB = document.getElementById('bb-fab-close');
  var panel = document.getElementById('bb-fab-panel');
  var call = document.getElementById('bb-call-link');
  var reqBtn = document.getElementById('bb-request-toggle');
  var form = document.getElementById('bb-fab-form');
  if (!fab || !toggle) return;

  function setOpen(open) {
    fab.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
  }
  toggle.addEventListener('click', function () { setOpen(!fab.classList.contains('is-open')); });
  if (closeB) closeB.addEventListener('click', function () { setOpen(false); });

  // Anfrage -> Formular aus-/einklappen
  if (reqBtn && form) {
    reqBtn.addEventListener('click', function () {
      var open = !form.classList.contains('is-open');
      form.classList.toggle('is-open', open);
      reqBtn.classList.toggle('is-active', open);
      reqBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // HubSpot-Tracking beim Anruf-Klick (greift nach Marketing-Consent)
  if (call) {
    call.addEventListener('click', function () {
      window._hsq = window._hsq || [];
      _hsq.push(['setPath', '/anruf-geklickt-floating-widget']);
      _hsq.push(['trackPageView']);
    });
  }
})();